'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PolicyMobile = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(PolicyMobile, _Component);

  function PolicyMobile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PolicyMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PolicyMobile.__proto__ || (0, _getPrototypeOf2.default)(PolicyMobile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentNav: _this.props.location.pathname.split('/')[2] || 'intro'
    }, _this.handleChangeNav = function (nav) {
      _this.setState({ currentNav: nav });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PolicyMobile, [{
    key: 'render',
    value: function render() {
      var styles = require('./PolicyMobile.scss');
      var currentNav = this.state.currentNav;

      return _react2.default.createElement(
        _reactBootstrap.Row,
        {
          className: styles.policy,
          style: currentNav === 'thong-tin-lien-he' ? { height: '80vh' } : { height: '100%' }
        },
        _react2.default.createElement(
          _reactBootstrap.Col,
          { md: 9 },
          currentNav === 'thong-tin-lien-he' && _react2.default.createElement(_components.Contacts, {
            mobile: true,
            customTitleStyle: {
              fontSize: 20,
              fontWeight: 'bold'
            },
            customStyle: { fontSize: 12 }
          }),
          currentNav === 'bao-mat' && _react2.default.createElement(_components.Privacy, {
            mobile: true,
            customTitleStyle: {
              fontSize: 20,
              fontWeight: 'bold'
            },
            customStyle: { fontSize: 12 },
            customHeaderStyle: { fontSize: 16 }
          }),
          currentNav === 'quy-che-hoat-dong' && _react2.default.createElement(_components.ActivityRuleMobile, null),
          currentNav === 'giai-quyet-tranh-chap' && _react2.default.createElement(_components.Conflit, {
            mobile: true,
            customTitleStyle: {
              fontSize: 20,
              fontWeight: 'bold'
            },
            customStyle: { fontSize: 12 }
          })
        )
      );
    }
  }]);
  return PolicyMobile;
}(_react.Component), _class.propTypes = {
  params: _react.PropTypes.object,
  location: _react.PropTypes.object
}, _temp2);
exports.default = PolicyMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/PolicyMobile/index.js
// module id = 1622
// module chunks = 0